import { useSetupMFAWebAuthn as useSetupMFAWebAuthnFlow } from 'mfa'
import { prepareWebAuthnRegistration } from '../api/prepareWebAuthnRegistration'
import { finishWebAuthnRegistration } from '../api/finishWebAuthnRegistration'
import { apiRequest } from '../utils/apiRequest'

export const useSetupMFAWebAuthn = ({ isFromSettings = false } = {}) =>
  useSetupMFAWebAuthnFlow({
    isFromSettings,
    prepareRegistration: () => apiRequest(prepareWebAuthnRegistration),
    finishRegistration: (data) => apiRequest(finishWebAuthnRegistration, data),
  })
